import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import type { Theme } from '@mui/material/styles';

const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={(theme: Theme) => ({
      '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      },
      html: {
        width: '100%',
        height: '100%',
        '-ms-text-size-adjust': '100%',
        '-webkit-overflow-scrolling': 'touch',
      },
      body: {
        width: '100%',
        height: '100%',
      },
      '#root': {
        width: '100%',
        height: '100%',
      },
      '.safetyDoc ul': {
        marginLeft: '25px',
      },
      input: {
        '&[type=number]': {
          MozAppearance: 'textfield',
          '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
          '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' },
        },
      },
      textarea: {
        '&::-webkit-input-placeholder': { color: theme.palette.text.disabled },
        '&::-moz-placeholder': { opacity: 1, color: theme.palette.text.disabled },
        '&:-ms-input-placeholder': { color: theme.palette.text.disabled },
        '&::placeholder': { color: theme.palette.text.disabled },
      },
      a: { color: theme.palette.primary.main },
      img: { display: 'block', maxWidth: '100%' },
      '.editDocButton': {
        top: '10px',
        right: '10px',
      },
      '.css-1m3p18l': {
        border: '0px !important',
      },
      '.css-1spcvrl': {
        border: '0px !important',
      },

      // apexcharts
      '.apexcharts-tooltip,.apexcharts-xaxistooltip': {
        border: '0 !important',
        boxShadow: `${(theme as any).customShadows?.z24} !important`,
        color: `${theme.palette.text.primary} !important`,
        borderRadius: `${(theme.shape as any).borderRadiusSm}px !important`,
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      '.apexcharts-tooltip-title': {
        border: '0 !important',
        fontWeight: theme.typography.fontWeightBold,
        backgroundColor: `${(theme.palette.grey as any)['500_16']} !important`,
        color: theme.palette.text[theme.palette.mode === 'light' ? 'secondary' : 'primary'],
      },
      '.apexcharts-xaxistooltip-bottom': {
        '&:before': {
          borderBottomColor: 'transparent !important',
        },
        '&:after': {
          borderBottomColor: `${theme.palette.background.paper} !important`,
        },
      },
      '.apexcharts-legend': {
        padding: '0 !important',
      },
      '.apexcharts-legend-series': {
        alignItems: 'center',
        display: 'flex !important',
      },
      '.apexcharts-legend-marker': {
        marginTop: '-2px !important',
        marginRight: '8px !important',
      },
      '.apexcharts-legend-text': {
        lineHeight: '18px',
        textTransform: 'capitalize',
      },
    })}
  />
);

export default GlobalStyles;
